<app-spinner [active]="loading"></app-spinner>
<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-6.jpg)' }"
  class="content-header"
>
  <h2 class="header-title">Jumpers</h2>
</div>
<app-modal
  [active]="modal.active"
  [data]="modal.data"
  (confirmed)="modalConfirmed($event)"
  (denied)="modalDenied($event)"
>
</app-modal>
<div class="random-actions">

  <div class="app-dropdown" *ngIf="userIsSysAdmin && bases !== []">
    <app-dropdown
      [choice]="selectedBase"
      [options]="bases"
      key="name"
      label="Base"
      (selectedDropdownItem)="selectHomeBase($event)"
    ></app-dropdown>
  </div> 
  <div *ngIf="!userIsSysAdmin || bases === []">
    <span class="base"> Base: {{ userInfo.baseName }} ({{ userInfo.baseCode }})</span>      
  </div>

  <app-dropdown class="app-dropdown"
    [(choice)]="selectedActive"
    label=""
    [options]="[
      { name: 'Active Jumpers', value: 'active' },
      { name: 'Inactive Jumpers', value: 'inactive' }
    ]"
    key="value"
    (selectedDropdownItem)="selectActive($event)"
  ></app-dropdown>
</div>
<app-table
  hasActions="true"
  [settings]="settings"
  [rows]="jumpers"
  [columns]="headings"
  (deleted)="confirmDelete($event)"
  [tableCellTemplate]="cellTemplate"
>
  <ng-template #cellTemplate let-cell="cell">
    <div class="cell">
      <span>{{ cell.value }}</span>
    </div>
  </ng-template>
</app-table>
